<div class="image-background flex justify-center flex-col xl:px-[80px] xl:py-[120px] md:px-[40px] md:py-[100px] sl:px-[16px] sl:py-[40px]">
    <div class="text-section flex flex-col items-center text-center">
        <span class="title font-black xl:text-72 md:text-48 sl:text-32">A Customized</span>
        <span class="title font-black xl:text-72 md:text-48 sl:text-32">Professional Services Hub.</span>
        <span class="sub-title font-bold xl:mt-8 md:mt-[24px] sl:mt-[16px] xl:text-48 md:text-32 sl:text-16">Devoted to Your Success</span>
        <span class="text font-normal xl:mt-8 md:mt-[24px] sl:mt-[16px] xl:text-20 md:text-16 sl:text-12 md:leading-180 sl:leading-120">We specialize in crafting bespoke IT solutions that drive business excellence. Our commitment is to deliver</span>
        <span class="text font-normal xl:text-20 md:text-16 sl:text-12 md:leading-180 sl:leading-120">innovative, reliable services that meet and exceed your expectations.</span>
    </div>
    <div class="xl:mt-[120px] md:mt-[100px] sl:mt-[40px]">
        <om-marquee [animationDuration]="'8s'" [marqueeGap]="'10rem'" [pauseOnHover]="true" styleClass="custom-marquee"
            [scrollable]="true">
            <ng-template>
                <img class="item" src="../../../assets/images/heartland.svg" />
            </ng-template>
            <ng-template>
                <img class="item" src="../../../assets/images/xenial.svg" />
            </ng-template>
            <ng-template>
                <img class="item" src="../../../assets/images/sentral.svg" />
                </ng-template>
                <ng-template>
                    <img class="item" src="../../../assets/images/ezidebit.svg" />
                </ng-template>
                <ng-template>
                    <img class="item" src="../../../assets/images/away.svg" />
            </ng-template>
        </om-marquee>
    </div>
</div>
